// Sentry — JS chyby z admin SPA / editoru / dema.
// Záměrně @sentry/vue, NE @sentry/nuxt: nuxt.config má `ssr: false` a build je
// `nuxi generate` → v runtime servírje statiku nginx, žádný nitro server neběží,
// takže serverová půlka @sentry/nuxt je mrtvá váha, která jen rozbíjí build.
// Klientské weby (host_router → Django render) tímto NEJSOU pokryté — ty hlásí
// chyby přes backendovou Sentry.
import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig().public
  const dsn = config.sentryDsn
  if (!dsn) return

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn,
    environment: config.sentryEnvironment || 'production',
    release: config.sentryRelease || undefined,
    // Performance tracing a session replay vypnuté — právě ty spálí free tier.
    // Zapnout až se sample rate < 1 a s vědomím kvóty.
    tracesSampleRate: 0,
    // Bez PII: žádné e-maily/IP. Editor je multi-tenant, breadcrumbs by jinak
    // vozily obsah klientských webů do Sentry.
    sendDefaultPii: false,
    // Šum, který nevypovídá o našem kódu: rozbité rozšíření v prohlížeči,
    // přerušený chunk load po deployi, ResizeObserver noise.
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      /^Failed to fetch dynamically imported module/,
      /^Importing a module script failed/,
    ],
    denyUrls: [/extensions\//i, /^chrome:\/\//i, /^moz-extension:\/\//i],
  })

  // Dělení podle části appky — ať jde v Sentry filtrovat (demo / admin / editor).
  const router = useRouter()
  const tagArea = (path: string) => {
    const area = path.startsWith('/demo')
      ? 'demo'
      : path.startsWith('/admin')
        ? 'admin'
        : 'client-editor'
    Sentry.setTag('area', area)
  }
  tagArea(router.currentRoute.value.path)
  router.afterEach((to) => tagArea(to.path))
})
